import { CERTIFICATE_LANG } from "enums/certificate";

interface Props {
  lang: CERTIFICATE_LANG;
}
const SkeletonCertificate: React.FC<Props> = ({ lang }) => {
  return (
    <img
      src={
        lang === CERTIFICATE_LANG.FA
          ? "https://faradars.org/wp-content/uploads/2025/12/07/default-certificate-fa.svg"
          : "https://faradars.org/wp-content/uploads/2026/07/11/default-certificate-english.svg"
      }
      alt="certitifcate image"
      width={960}
      height={683}
      aria-hidden
      decoding="async"
      className="h-full w-full object-contain"
    />
  );
};

export default SkeletonCertificate;
